<div>
  <div>
    <div class="container-fluid">
      <div class="row">
        <form id="msform" name="hostPartyForm">
          <br><fieldset>
            <div class="form-card">
              <div class="row">
                <div class="col-12">
                  <h2 class="pageheader">
                    Thank you for Hosting! Please download the following invite and send to family
                    and friends. Please make it clear in your message the time and timezone for
                    your Screening Party.
                  </h2>
                </div>

              </div> <br><br>
              <div class="row" style="padding:30px 45px; background: #da2c43">
                <div class="row">



                  <a href="{{screeningParty.invitationLink}}" target="_blank"> <i class="fa fa-download"
                      style="color:#fff; font-size: 42px" aria-hidden="true"> </i></a>

                </div>

                <div class="row" style="padding:21px; color:#171717; background: #fff">


                  <h4 style=" text-align:center"> <img src="{{screeningParty.imageUrl}}" alt="Avatar"
                      style="width:100px; height:100px;  border-radius: 50%;"></h4>

                  <h2 class="headerone">You are invited ! </h2>
                  <h5 th:text="${movieName}" style="text-align: center; font-weight:600;">{{screeningParty.movieName}}</h5>


                  <h5
                    style="text-align: center; color:#000000 !important; font-size: 14px !important; font-weight:600;">
                    HOST'S TIMEZONE <span>{{screeningParty.meetingDateTime | date:'medium'}} {{timezone}}</span></h5>

                  <h5 style="text-align: center; color:#000000 !important; font-size: 12px !important;">Hosted by 
                    <span *ngIf = "screeningParty.lastName">{{screeningParty.firstName + ' ' + screeningParty.lastName}}</span>
                    <span *ngIf = "!screeningParty.lastName">{{screeningParty.firstName}}</span></h5>
                  <p class="contentChange">
                    I invite you to attend a fun and engaging Cinejoy Screening party! It’s like a book
                    club but for great new films. Make sure to go to the MOVIE PAGE
                    and watch the featured film prior to the party as that is the fun
                    of it and the center point of the Party's conversations and sharing.
                    Then make sure to put the Party and Zoom Link below into your calendar
                    and Join us at the appointed date/time. Thank you for supporting the
                    film and joining the community party!
                  </p>


                  <div class="row">
                    <div style="float:left; width: fit-content;">
                      <p class="contentChange">Party Link: <a href="{{screeningParty.meetingLink}}"> <span
                            >{{screeningParty.meetingLink}}</span></a></p>
                    </div>

                    <div style="float:right;margin-top: 2vh;">
                      <a style="text-decoration: none; background: #DE1B36; border-radius: 5px; align-items: center; padding: 10px 15px; font-weight: 600;
                                    font-size: 16px; color:#fff; float: right; cursor: pointer;" (click)="navigateShowcase(screeningParty)">MOVIE PAGE</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button class="previous action-button-previous" style="float:right; margin-top:1%; border-radius:5px;"
              onclick="location.href='/cinejoy/screening-parties/join';">Exit</button>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</div>
